"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = MenuFooter;
exports.styles = void 0;

var _react = _interopRequireWildcard(require("react"));

var _makeStyles = _interopRequireDefault(require("@material-ui/core/styles/makeStyles"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _CmsSlot = _interopRequireDefault(require("../CmsSlot"));

var _MenuContext = _interopRequireDefault(require("./MenuContext"));

var styles = function styles(theme) {
  return {
    root: {
      padding: theme.spacing(2)
    }
  };
};

exports.styles = styles;
var useStyles = (0, _makeStyles["default"])(styles, {
  name: 'RSFMenuFooter'
});

function MenuFooter(_ref) {
  _ref = Object.assign({}, {}, _ref);
  var classes = _ref.classes,
      item = _ref.item;
  classes = useStyles({
    classes: classes
  });

  var _useContext = (0, _react.useContext)(_MenuContext["default"]),
      renderFooter = _useContext.renderFooter;

  if (typeof renderFooter === 'function') {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: classes.root
    }, renderFooter(item));
  }

  if (item.footer) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: classes.root
    }, /*#__PURE__*/_react["default"].createElement(_CmsSlot["default"], null, item.footer));
  }

  return null;
}

MenuFooter.propTypes = {
  /**
   * The menu item record
   */
  item: _propTypes["default"].object
};
